<script lang="ts" setup>
onMounted(() => {
  throw new Error('This is just a test error for testing Sentry configuration')
})
</script>

<template>
  <h1>Test error page</h1>
</template>
